// WorkOrdersStatsRow.tsx — Sprint 11. Four summary cards across the
// top of the page (Open / In Progress / Completed / Total). Stateless:
// counts come from the orchestrator's `useMemo` over workOrders.
import React from 'react';
import { Card, Col, Row, Typography } from 'antd';

const { Text } = Typography;

export interface WorkOrdersStatsRowProps {
  open:       number;
  inProgress: number;
  completed:  number;
  total:      number;
}

export const WorkOrdersStatsRow: React.FC<WorkOrdersStatsRowProps> = ({
  open, inProgress, completed, total,
}) => {
  const stats = [
    { label: 'Open',        count: open,       color: '#3182ce', bg: '#ebf8ff' },
    { label: 'In Progress', count: inProgress, color: '#dd6b20', bg: '#fffaf0' },
    { label: 'Completed',   count: completed,  color: '#38a169', bg: '#f0fff4' },
    { label: 'Total',       count: total,      color: '#718096', bg: '#f8fafc' },
  ];

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      {stats.map(stat => (
        <Col span={6} key={stat.label}>
          <Card
            size="small" bordered={false}
            style={{ borderRadius: 10, background: stat.bg, border: `1px solid ${stat.color}20` }}
          >
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 28, fontWeight: 700, color: stat.color }}>{stat.count}</div>
              <Text style={{ color: stat.color, fontWeight: 500, fontSize: 13 }}>{stat.label}</Text>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};
